'use client';

import ServicePillarsSection from '@/app/homepage/components/ServicePillarsSection';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

export default function ServiciosPage() {
  return (
    <main className="bg-black text-white min-h-screen">
      <Header />
      <ServicePillarsSection />
      <Footer />
    </main>
  );
}